import {InjectionToken} from '@angular/core';
import {OnBoardingGuideService} from './services/on-boarding-guide.service';

export const ON_BOARDING_GUIDES = new InjectionToken<OnBoardingGuideService>('guide');
